import React, { useState, useRef, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";
import wide from "../../images/cdac-white.png";
import "./../../styles/Signin.css";
import "./../../styles/gradient.css";
import "../../styles/DecoyLogin.css";
import cdac from "../../images/main-logo.png";
import csmartlight from "../../images/dashboard_illustration.png";
import csmartdark from "../../images/csmartdark.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "./../../styles/NewSignin.css";

// Import carousel images
import wordcloud from "../../images/wrd.png";
import social from "../../images/illustration.png";
import sm from "../../images/kindpng_1449468.png";

const PageTemplate = (props) => {
  // Carousel state
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesRef = useRef(null);

  // Carousel content
  const sliderContent = [
    {
      title: "Welcome to C-SMART",
      content:
        "Our project is dedicated to providing you with powerful insights and analytics across various social media platforms. With our innovative tool, you can gain comprehensive understanding and analysis of your social media presence, all in one place.",
      sliderImg: csmartlight,
      imgClass: "img-medium",
    },

    {
      title: "Unlock the Power of C-SMART",
      content:
        "Our project is dedicated to providing you with powerful insights and analytics across various social media platforms. With our innovative tool, you can gain comprehensive understanding and analysis of your social media presence, all in one place.",
      sliderImg: wordcloud,
      // imgClass: "img-large",
      imgClass: "img-medium",
    },

    {
      title: "Harness Insights with C-SMART",
      content:
        "Gain valuable insights into audience engagement, content performance, and trending topics across all your social media channels.",
      sliderImg: social,
      imgClass: "img-medium",
    },

    {
      title: "Empower Your Strategy with C-SMART",
      content:
        "Our intuitive dashboard empowers you to make informed decisions, optimize your strategy, and maximize your online presence with ease. From monitoring key metrics to identifying emerging trends, C-SMART equips you with the tools you need to stay competitive in the dynamic world of social media marketing.",
      sliderImg: sm,
      imgClass: "img-medium",
    },
  ];

  // Carousel functions
  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === sliderContent.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? sliderContent.length - 1 : prev - 1
    );
  };

  // Auto-advance the slides every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", disableRightClick);
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
    };
  }, []);

  return (
    <div className="signin__container">
      <div className="signin__content">
        <div className="signin__left-panel">
          {/* Adding wide logo on top of carousel */}
          <div className="signin__logo-container">
            <img src={wide} alt="CDAC Logo" className="signin__logo-wide" />
          </div>

          {/* Carousel container */}
          <div className="signin__carousel-container" ref={slidesRef}>
            {sliderContent.map((item, index) => (
              <div
                key={index}
                className={`signin__slide ${
                  index === currentSlide ? "active" : ""
                }`}
              >
                <div className="signin__slide-content">
                  <div className="signin__slide-image-container">
                    <img
                      src={item.sliderImg}
                      alt="C-SMART Feature"
                      className={`signin__slide-image ${item.imgClass}`}
                    />
                  </div>
                  <div className="signin__slide-text">
                    <h2 className="signin__slide-title">{item.title}</h2>
                    <div className="signin__slide-divider"></div>
                    <p className="signin__slide-description">{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel controls */}
          <div className="signin__carousel-controls">
            <button
              onClick={prevSlide}
              className="signin__carousel-button signin__prev"
              aria-label="Previous slide"
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>

            <div className="signin__carousel-indicators">
              {sliderContent.map((_, index) => (
                <button
                  key={index}
                  className={`signin__indicator ${
                    index === currentSlide ? "active" : ""
                  }`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                ></button>
              ))}
            </div>

            <button
              onClick={nextSlide}
              className="signin__carousel-button signin__next"
              aria-label="Next slide"
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>

          <div className="signin__copyright-text">
            Copyright © {new Date().getFullYear()}
            <br />
            Designed and Developed by CDAC
          </div>

          <div className="signin__decorative-circles">
            <div className="signin__circle signin__circle-1"></div>
            <div className="signin__circle signin__circle-2"></div>
            <div className="signin__circle signin__circle-3"></div>
            <div className="signin__circle signin__circle-4"></div>
          </div>

          <div className="signin__decorative-shapes">
            {/* Original shapes */}
            <div className="signin__shape signin__shape-1"></div>
            <div className="signin__shape signin__shape-2"></div>

            {/* New shapes */}
            <div className="signin__square signin__square-1"></div>
            <div className="signin__square signin__square-2"></div>

            <div className="signin__triangle signin__triangle-1"></div>
            <div className="signin__triangle signin__triangle-2"></div>

            <div className="signin__curved-shape signin__curved-shape-1"></div>
            <div className="signin__curved-shape signin__curved-shape-2"></div>

            {/* Dot patterns */}
            <div className="signin__dot signin__dot-1"></div>
            <div className="signin__dot signin__dot-2"></div>
            <div className="signin__dot signin__dot-3"></div>
            <div className="signin__dot signin__dot-4"></div>
            <div className="signin__dot signin__dot-5"></div>
            <div className="signin__dot signin__dot-6"></div>
            <div className="signin__dot signin__dot-7"></div>
            <div className="signin__dot signin__dot-8"></div>

            {/* Wave effect */}
          </div>
        </div>

        <div className="signin__right-panel">
     {/* <img src={csmartdark} alt="C-SMART Logo" className="tool-logo" /> */}

          {/* Right panel content will be added by the implementation */}
          <div className="signin__form-container">
            {/* Content to be replaced in child components */}
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTemplate;
